<template>
  <div>
    <portal to="modal-button">
      <div
        class="dib"
        @click="modalIsOpen = true">
        <v-button
          class="b--white hover-bg-blue hover-mid-gray mr4-ns white"
          content="See the Video"/>
      </div>
    </portal>

    <portal to="modal-window">
      <transition name="fade">
        <div
          v-if="modalIsOpen"
          class="bg-blue-gray-75 fixed left-0 top-0 vh-100 vw-100 white z-9999">
          <div class="center cf mw12 h-100 w-100">
            <div
              v-on-clickaway="away"
              class="cf ph2 pt5 w-100">
              <div
                class="close fr mb4 pointer"
                @click="modalIsOpen = false">
                <div class="bg-animate bg-white close-bar"/>
                <div class="bg-animate bg-white close-bar"/>
              </div>
              <div
                class="aspect-ratio aspect-ratio--16x9 bg-blue-gray center container">
                <iframe
                  width="560"
                  height="315"
                  class="aspect-ratio--object cover"
                  src="https://www.youtube.com/embed/lzxDN69HfaY?rel=0"
                  frameborder="0"
                  allow="autoplay; encrypted-media"
                  allowfullscreen/>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </portal>
  </div>
</template>

<script>
import VButton from './VButton'
import { directive as onClickaway } from 'vue-clickaway'

export default {
  name: 'Modal',

  components: {
    VButton
  },

  directives: {
    onClickaway
  },

  data () {
    return {
      modalIsOpen: false
    }
  },

  methods: {
    away () {
      this.modalIsOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../assets/styles/_variables.scss';

.close {
  width: 40px;
  &:hover .close-bar {
    background-color: $colorBlue;
  }
}

.close-bar {
  margin-bottom: 6px;
  width: 40px;
  height: 4px;
  &:first-child {
    transform: rotate(45deg) translateY(7px);
  }
  &:last-child {
    transform: rotate(-45deg) translateY(-7px);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .15s
}

.fade-enter,
.fade-leave-to {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/components/VModal.vue